import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { spaceXL } from '@xingternal/tokens';

export const ModalContent = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const ResetButton = styled(Button)`
  margin-top: 20px;
  margin-bottom: ${spaceXL};
  width: 100%;
`;
